const Validity = {
  VALID: "",
  INVALID: "invalid",
};

export default Validity;
